import { DateTime } from 'luxon';

/**
 * Date utility functions for formatting and manipulation
 */
export class DateUtils {
  /**
   * Format DateTime for display
   */
  static formatDate(date: DateTime | string): string {
    if (!date) return '';

    try {
      const dateTime = typeof date === 'string' ? DateTime.fromISO(date) : date;
      if (!dateTime.isValid) return typeof date === 'string' ? date : '';
      return dateTime.toLocaleString(DateTime.DATETIME_MED);
    } catch (error) {
      console.error('Error formatting date:', error);
      return typeof date === 'string' ? date : '';
    }
  }

  /**
   * Format date to ISO string for API
   */
  static toISOString(date: Date): string {
    return DateTime.fromJSDate(date).toISO() || date.toISOString();
  }

  /**
   * Check if date is valid
   */
  static isValidDate(dateString: string): boolean {
    if (!dateString) return false;
    return DateTime.fromISO(dateString).isValid;
  }

  /**
   * Get relative time (e.g., "2 days ago")
   */
  static getRelativeTime(dateString: string): string {
    if (!dateString) return '';

    try {
      const date = DateTime.fromISO(dateString);
      if (!date.isValid) return dateString;

      const relative = date.toRelative();
      return relative || dateString;
    } catch (error) {
      console.error('Error calculating relative time:', error);
      return dateString;
    }
  }
}
